import React from 'react';
import { useLocation } from 'react-router-dom';

import AppLoading from './shared/displayComponents/appLoadingIndicator';
import { useFetchAccessTokens } from './shared/queries/auth';
import config from './config';
import {
  applyOptionalSessionExpiryCap,
  getExpirationDateFromAuthTokens,
} from './utils/tokenExpiryFromJwt';

const AuthComponent = () => {
  const query = useLocation().search;

  useFetchAccessTokens({
    params: { query },
    onSuccess: data => {
      // data will include the access and refresh tokens
      localStorage.setItem(config.AUTH.ID_TOKEN_KEY, data.id_token);
      // Avoid setItem(undefined) — browsers coerce to the string "undefined"
      if (data.refresh_token) {
        localStorage.setItem(config.AUTH.REFRESH_TOKEN_KEY, data.refresh_token);
      } else {
        localStorage.removeItem(config.AUTH.REFRESH_TOKEN_KEY);
      }
      const expiry = applyOptionalSessionExpiryCap(
        getExpirationDateFromAuthTokens(data.id_token, data.expires_in),
      );
      localStorage.setItem(config.AUTH.EXPIRES_IN_KEY, expiry.toString());
      // Redirect to the base url for the site
      window.location.href = '/';
    },
  });

  return <AppLoading isLoading showNoClientAccessMessage={false} />;
};

export default AuthComponent;
